export type Cleanup = () => void;

export const noopCleanup = (): void => {
	// Nothing to cleanup...
};
